import React, { useState, useEffect } from 'react';
import { FaSave, FaCog } from 'react-icons/fa';

const IndstillingerAPI = () => {
  const [apiSettings, setApiSettings] = useState({
    update_limit: 80,
    update_interval: 24
  });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchApiSettings();
  }, []);

  const fetchApiSettings = async () => {
    try {
      const response = await fetch('/api/indstillinger/api');
      if (response.ok) {
        const data = await response.json();
        setApiSettings(data);
      }
    } catch (error) {
      console.error('Error fetching API settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/indstillinger/api', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(apiSettings),
      });

      if (response.ok) {
        setMessage('API indstillinger gemt!');
        setTimeout(() => setMessage(''), 3000);
      } else {
        const errorData = await response.json();
        setMessage(`Fejl: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error saving API settings:', error);
      setMessage('Fejl ved gemning af API indstillinger');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-falck-blue"></div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">API Indstillinger</h1>
        <p className="text-gray-600 mt-1">Administrer hvor mange biler der opdateres pr. dag og hvor ofte</p>
      </div>

      {message && (
        <div className="mb-4 p-4 bg-blue-100 border border-blue-400 text-blue-700 rounded">
          {message}
        </div>
      )}

      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg shadow p-6">
        <div className="flex items-center mb-6">
          <FaCog className="text-falck-blue mr-3 text-xl" />
          <h2 className="text-xl font-semibold text-gray-800">API Konfiguration</h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Maksimale opdateringer per dag
            </label>
            <select
              value={apiSettings.update_limit}
              onChange={(e) => setApiSettings({...apiSettings, update_limit: parseInt(e.target.value)})}
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-falck-blue"
            >
              {Array.from({length: 10}, (_, i) => (i + 1) * 10).map(value => (
                <option key={value} value={value}>{value}</option>
              ))}
            </select>
            <p className="text-sm text-gray-500 mt-1">
              Antal biler der kan opdateres pr. dag via API
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Opdateringsinterval
            </label>
            <select
              value={apiSettings.update_interval}
              onChange={(e) => setApiSettings({...apiSettings, update_interval: parseInt(e.target.value)})}
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-falck-blue"
            >
              <option value={24}>1 dag</option>
              <option value={48}>2 dage</option>
              <option value={72}>3 dage</option>
              <option value={96}>4 dage</option>
              <option value={120}>5 dage</option>
              <option value={144}>6 dage</option>
              <option value={168}>7 dage</option>
            </select>
            <p className="text-sm text-gray-500 mt-1">
              Hvor ofte systemet automatisk opdaterer biloplysninger
            </p>
          </div>

          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-medium text-gray-800 mb-2">Nuværende konfiguration</h3>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="font-medium text-gray-700">Opdateringer per dag:</span>
                <span className="ml-2 text-gray-900">{apiSettings.update_limit}</span>
              </div>
              <div>
                <span className="font-medium text-gray-700">Interval:</span>
                <span className="ml-2 text-gray-900">{apiSettings.update_interval / 24} dage</span>
              </div>
            </div>
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-falck-blue text-white px-6 py-2 rounded-lg hover:bg-falck-dark-blue transition-colors flex items-center"
            >
              <FaSave className="mr-2" />
              Gem ændringer
            </button>
          </div>
        </form>
      </div>

      <div className="mt-6 bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
        <h3 className="text-lg font-medium text-yellow-800 mb-2">⚠️ Vigtig information</h3>
        <ul className="text-sm text-yellow-700 space-y-1">
          <li>• Højere opdateringsfrekvens kan påvirke systemets ydeevne</li>
          <li>• Færre opdateringer per dag kan reducere API-omkostninger</li>
          <li>• Ændringer træder i kraft ved næste automatiske opdatering</li>
        </ul>
      </div>
    </div>
  );
};

export default IndstillingerAPI;
